<script setup lang="ts">
// Step 3: goals & scenarios — a checklist with checkmarks animating in,
// connected by a soft flow line to a target glyph on the right.
</script>

<template>
  <div class="relative h-full w-full flex items-center justify-center">
    <svg
      viewBox="0 0 320 220"
      class="h-full w-auto"
      role="img"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="wg-goals-accent" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stop-color="rgb(var(--accent))" />
          <stop offset="100%" stop-color="#22c55e" />
        </linearGradient>
      </defs>

      <!-- checklist card -->
      <g transform="translate(38 38)">
        <rect width="170" height="144" rx="14" fill="rgb(var(--surface))" stroke="rgb(var(--border))" />

        <!-- row 1 (done) -->
        <g transform="translate(18 24)">
          <rect width="22" height="22" rx="6" fill="rgb(var(--accent))" />
          <path d="M6 11 l4 4 l8 -8" stroke="white" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
          <rect x="34" y="6" width="100" height="6" rx="3" fill="rgb(var(--text))" opacity="0.8" />
          <rect x="34" y="16" width="64" height="5" rx="2.5" fill="rgb(var(--text-muted))" opacity="0.5" />
        </g>

        <!-- row 2 (done) -->
        <g transform="translate(18 60)">
          <rect width="22" height="22" rx="6" fill="rgb(var(--accent))" opacity="0.85" />
          <path d="M6 11 l4 4 l8 -8" stroke="white" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
          <rect x="34" y="6" width="88" height="6" rx="3" fill="rgb(var(--text))" opacity="0.8" />
          <rect x="34" y="16" width="74" height="5" rx="2.5" fill="rgb(var(--text-muted))" opacity="0.5" />
        </g>

        <!-- row 3 (in progress, pulsing) -->
        <g transform="translate(18 96)">
          <rect width="22" height="22" rx="6" fill="none" stroke="rgb(var(--accent))" stroke-width="2" stroke-dasharray="3 3">
            <animateTransform attributeName="transform" type="rotate" from="0 11 11" to="360 11 11" dur="6s" repeatCount="indefinite" />
          </rect>
          <rect x="34" y="6" width="120" height="6" rx="3" fill="rgb(var(--text))" opacity="0.55" />
          <rect x="34" y="16" width="56" height="5" rx="2.5" fill="rgb(var(--text-muted))" opacity="0.35" />
        </g>
      </g>

      <!-- flow line from card to target -->
      <path
        d="M210 110 C 240 110, 250 110, 268 110"
        stroke="url(#wg-goals-accent)"
        stroke-width="2"
        fill="none"
        stroke-dasharray="4 4"
      >
        <animate attributeName="stroke-dashoffset" from="0" to="-16" dur="1.4s" repeatCount="indefinite" />
      </path>

      <!-- target -->
      <g transform="translate(268 110)">
        <circle r="26" fill="rgb(var(--surface-elevated))" stroke="rgb(var(--border))" />
        <circle r="18" fill="none" stroke="rgb(var(--accent))" stroke-width="2" />
        <circle r="10" fill="none" stroke="rgb(var(--accent))" stroke-width="2" />
        <circle r="4" fill="rgb(var(--accent))" />
      </g>
    </svg>
  </div>
</template>
